module.exports = __webpack_public_path__ + "static/bastian-nolte-p-f-4ee4b4a539d5749330d5792c6631edd5.png";